document.addEventListener('DOMContentLoaded', function() {
  attachCloseButtonListeners();
});

document.addEventListener('cart-drawer:refreshed', function() {
  attachCloseButtonListeners();
});

function attachCloseButtonListeners() {
  let closeButtons = document.querySelectorAll('[data-close-cart]');
  closeButtons.forEach(button => {
    button.removeEventListener('click', closeCartDrawer);
    button.addEventListener('click', closeCartDrawer);
  });
}
function closeCartDrawer() {
  document.getElementById('cart-drawer').hide();
}